import React from 'react';
import TextTruncate from '../common/TextTruncate';


function IndustryCard({ name, logo }: { name: string; logo: string; key?: any }) {
    return (
        <div className="cht-p-3">
            <div className="cht-bg-white cht-rounded-[20px] cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-shadow-float hover:cht-border-[#3e57da]/40 cht-transition-all cht-duration-300 cht-p-6 sm:cht-p-8 cht-flex cht-flex-col cht-items-center cht-text-center cht-h-[220px] cht-justify-center cht-group !cht-font-body">
                <div className="cht-w-20 cht-h-20 cht-rounded-2xl cht-bg-slate-50 cht-border cht-border-slate-100 cht-flex cht-items-center cht-justify-center cht-mb-4 group-hover:cht-scale-110 cht-transition-transform cht-duration-200">
                    <img
                        src={logo}
                        className="cht-max-w-[56px] cht-max-h-[56px] cht-object-contain"
                        alt={name}
                    />
                </div>
                <h4 className="cht-text-base sm:cht-text-lg cht-font-bold cht-text-[#1e293b] group-hover:cht-text-[#3e57da] cht-transition-colors cht-line-clamp-2 cht-m-0">
                    {name}
                </h4>
            </div>
        </div>
    );
}

export default IndustryCard;